import { Component, ElementRef, Input, OnInit, Output, Renderer2, ViewChild, AfterViewInit, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { EventEmitter } from '@angular/core';
import { DhlFormControl } from '../../models/dhl-form-control';
import { Observable, Subject } from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {Constant} from '../../../constants/constants';
import { APP_Constants } from 'src/app/app.constant';
import { Modal } from 'src/app/common/modal/modal';
import { ModalConfigData } from 'src/app/common/modalconfig/modalconfig';

@Component({
    selector: 'app-form-field-autocomplete-v2',
    templateUrl: './form-field-autocomplete-v2.component.html',
    styleUrls: ['./form-field-autocomplete-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class FormFieldAutocompleteV2Component implements OnInit, AfterViewInit {

  @Input() configData: DhlFormControl;
  @Input() frmGroup: UntypedFormGroup;

  @Input() fieldMetadata;
  @Output() fieldAction = new EventEmitter();
  @Output() controlValue = new EventEmitter();

  @ViewChild('formControl', {static: true, read: ElementRef}) formControl: ElementRef;
  @ViewChild('inputEle', {static: true, read: ElementRef}) inputEle: ElementRef;

  placeholder: string = '';
  validationType: string = '';
  fieldType: string = '';
  fieldIcon: string = '';

  pickerToggle: boolean = false;

  // seach-com code
  public suggestionList: Observable<any[]>;
  private searchTerms = new Subject<any>();
  suggestion: boolean;
  public selectedItems: Array<any>;
  typing = false;
  searchStr = "";
  enum=Constant;
  editField: boolean;
  appService: any;
  isLoading: boolean;
  templateData: any;
  modalService: any;
  selfServiceConfig: boolean = false;

  constructor(private _eref: ElementRef, private renderer: Renderer2, public translate: TranslateService) {
    new Observable((ober) => {
      ober.next(["salman", "rifai"])
    }).subscribe((res: any) => {
      this.suggestionList = res;
    }); //[];

    this.suggestion = true;
  }

  ngOnInit() {
    if(this.configData.customFormFlag){
      this.selfServiceConfig = false;
    }
    else if(sessionStorage.getItem('isSelfServiceConfig'))
    {
      this.selfServiceConfig = true;
    }
    this.fieldType = this.fieldMetadata ? this.fieldMetadata.fieldType : 'search';
    this.fieldIcon = this.fieldMetadata ? this.fieldMetadata.fieldIcon : null;
    this.toggleDisable(this.configData['disabled']);
    if (this.configData.validation.length)
      this.fieldValueValidation(this.configData.validation);
  }

  ngAfterViewInit() {
    this.placeholder = this.configData.placeHolder
  }

  fieldValueValidation(validations) {
    validations.forEach((validataion: string | any) => {
      let element = (typeof validataion == "object" ? validataion.name : validataion);
      if (element === 'hidden') {
        if (!(this.frmGroup.get(this.configData.name)['hidden'] === false)) {
          this.frmGroup.get(this.configData.name)['hidden'] = true;
          this.configData.required = false;
          this.frmGroup.get(this.configData.name).clearValidators();
          this.frmGroup.get(this.configData.name).updateValueAndValidity();
        }
      }
    }, this);
  }

  toggleDisable(disabled) {
    if (disabled === true) {
      this.frmGroup.get(this.configData.name).disable();
      this.formControl.nativeElement.parentElement.classList.add('disabled');
    } else {
      this.frmGroup.get(this.configData.name).enable();
      this.formControl.nativeElement.parentElement.classList.remove('disabled');
    }
  }

  popFieldAction(e){
    this.fieldAction.emit(e);
  }

  @HostListener('document:keyup', ['$event'])
  @HostListener('document:keyup.Tab', ['$event'])
  @HostListener('document:click', ['$event'])
  onWindowClick(event) {
    if (!this._eref.nativeElement.contains(event.target))
      this.typing = false;
  }

  controlValueChange(e) {
    // this.controlValue.emit(e);
    console.log('change---->', e.target.value.trim())
    this.frmGroup.get(this.configData.name).setValue(e.target.value.trim());
  }

  onkeyupHandler(e) {
    if (e.target.value.trim().length >= 3) {
      this.typing = true;
    } else {
      this.typing = false;
    }
  }

  normalView() {
    throw new Error('Method not implemented.');
  }

  

  close() {
    this.searchStr = "";
    this.frmGroup.get(this.configData.name).setValue(this.searchStr);
    this.typing = false;
    this.renderer.removeAttribute(this.inputEle.nativeElement, 'placeholder');
    this.renderer.removeClass(this.inputEle.nativeElement.parentElement, 'active');
  }

  onselect(suggestion){

  }
}
